let balm = [

    {
        id:0,
        title:"퍼퓸 밤 카모",
        imgUrl:"/img/balm.jpg",
        content:"진득한 카모마일 | 부드러운 나무결 | 머스크",
        price:46+","+500
    },

    {
        id:1,
        title:"퍼퓸 밤 버가샌달",
        imgUrl:"/img/balm2.jpg",
        content:"지중해의 베르가못 | 쌉싸래한 청귤 | 샌달우드",
        price:46+ "," +500
    },

    {
        id:2,
        title:"퍼퓸 밤 라레",
        imgUrl:"/img/balm3.jpg",
        content:"이슬을 머금은 풋사과 | 화이트 튤립 | 샌달우드",
        price:46+","+500
    },

    {
        id:3,
        title:"퍼퓸 밤 스웨이드페어",
        imgUrl:"/img/balm4.jpg",
        content:"시원한 배 | 스웨이드 | 쌉쌀한 갈바넘",
        price:46+","+500
    }

]

export default balm;